module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [(_vm.fill_info == '') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "nev",
      "label": "Viselt neve",
      "name": "nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ]+",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.nev),
      callback: function($$v) {
        _vm.form.nev = $$v
      },
      expression: "form.nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "szuletesi_nev",
      "label": "Születési neve",
      "name": "szuletesi_nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ]+",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.szuletesi_nev),
      callback: function($$v) {
        _vm.form.szuletesi_nev = $$v
      },
      expression: "form.szuletesi_nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "szulhely",
      "label": "Születési hely",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+",
      "name": "szulhely",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.szulhely),
      callback: function($$v) {
        _vm.form.szulhely = $$v
      },
      expression: "form.szulhely"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "szulido",
      "label": "Születési dátum",
      "mask": "9999-99-99",
      "regexp_filter": "[0-9]+",
      "name": "szulido",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.szulido),
      callback: function($$v) {
        _vm.form.szulido = $$v
      },
      expression: "form.szulido"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "anyja_neve",
      "label": "Anyja neve",
      "name": "anyja_neve",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ]+",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.anyja_neve),
      callback: function($$v) {
        _vm.form.anyja_neve = $$v
      },
      expression: "form.anyja_neve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "adoazonosito_jel",
      "label": "Adóazonosító jel",
      "regexp_filter": "[0-9]{10}",
      "name": "adoazonosito_jel",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.adoazonosito_jel),
      callback: function($$v) {
        _vm.form.adoazonosito_jel = $$v
      },
      expression: "form.adoazonosito_jel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "lakcim",
      "label": "Állandó lakcím <span style='font-size: 10px; display: block; font-weight: 400'>(irányítószám, település, utca, házszám)</span>",
      "name": "lakcim",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.lakcim),
      callback: function($$v) {
        _vm.form.lakcim = $$v
      },
      expression: "form.lakcim"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "levcim",
      "label": "Levelezési cím <span style='font-size: 10px; display: block; font-weight: 400'>(irányítószám, település, utca, házszám)</span>",
      "name": "levcim",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.levcim),
      callback: function($$v) {
        _vm.form.levcim = $$v
      },
      expression: "form.levcim"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "taj_szam",
      "label": "TAJ szám",
      "regexp_filter": "[0-9]+",
      "name": "taj_szam",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.taj_szam),
      callback: function($$v) {
        _vm.form.taj_szam = $$v
      },
      expression: "form.taj_szam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "bank_nev",
      "label": "Számlavezető bank neve",
      "name": "bank_nev",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.bank_nev),
      callback: function($$v) {
        _vm.form.bank_nev = $$v
      },
      expression: "form.bank_nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "bankszamlaszam",
      "label": "Bankszámlaszám",
      "regexp_filter": "[0-9-]+",
      "name": "bankszamlaszam",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.bankszamlaszam),
      callback: function($$v) {
        _vm.form.bankszamlaszam = $$v
      },
      expression: "form.bankszamlaszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "allampolgarsag",
      "label": "Állampolgárság",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ]+",
      "name": "allampolgarsag",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.allampolgarsag),
      callback: function($$v) {
        _vm.form.allampolgarsag = $$v
      },
      expression: "form.allampolgarsag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "email",
      "label": "E-mail cím <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>",
      "name": "email",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "mobilszam",
      "label": "Mobilszám",
      "mask": "+99 99 / 999 9999",
      "regexp_filter": "[0-9]+",
      "name": "mobilszam",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.mobilszam),
      callback: function($$v) {
        _vm.form.mobilszam = $$v
      },
      expression: "form.mobilszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "palyazati_azonosito",
      "label": "Pályázati azonosító <span style='font-size: 10px; display: block; font-weight: 400'>(Az egyedi azonosító számot a pályázat befogadásáról szóló értesítő e-mailben kapta meg)</span>",
      "name": "palyazati_azonosito",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.palyazati_azonosito),
      callback: function($$v) {
        _vm.form.palyazati_azonosito = $$v
      },
      expression: "form.palyazati_azonosito"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "kutatas_cime",
      "label": "A Pályázat keretében támogatott kutatás címe <span style='font-size: 10px; display: block; font-weight: 400'>(pályázat beadásakor elfogadott cím)</span>",
      "name": "kutatas_cime",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.kutatas_cime),
      callback: function($$v) {
        _vm.form.kutatas_cime = $$v
      },
      expression: "form.kutatas_cime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "temavezeto_neve",
      "label": "Témavezető neve",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ]+",
      "name": "temavezeto_neve",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.temavezeto_neve),
      callback: function($$v) {
        _vm.form.temavezeto_neve = $$v
      },
      expression: "form.temavezeto_neve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Tudományterület <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>",
      "id": "tudomanyterulet",
      "name": "tudomanyterulet",
      "options": _vm.tudomanyteruletek,
      "errors": _vm.errors
    },
    on: {
      "onChange": _vm.tudomanyTeruletValt
    },
    model: {
      value: (_vm.form.tudomanyterulet),
      callback: function($$v) {
        _vm.form.tudomanyterulet = $$v
      },
      expression: "form.tudomanyterulet"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Tudomány- ill., művészeti ág <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>",
      "id": "tudomanyag",
      "name": "tudomanyag",
      "options": _vm.tudomanyagak,
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.tudomanyag),
      callback: function($$v) {
        _vm.form.tudomanyag = $$v
      },
      expression: "form.tudomanyag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Képzési terület kódja <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>",
      "id": "kepzesi_terulet",
      "name": "kepzesi_terulet",
      "options": _vm.kepzesi_teruletek,
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.kepzesi_terulet),
      callback: function($$v) {
        _vm.form.kepzesi_terulet = $$v
      },
      expression: "form.kepzesi_terulet"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "hallgatoi_kepzes",
      "label": "Tudományág szerinti Kar neve <span style='font-size: 10px; display: block; font-weight: 400'>(Alap-, Mesterképzés, Posztdoktor, Bolyai+ kategóriáknál)/Doktori Iskola neve (Doktori, Doktorvárományos kategóriáknál)</span>",
      "name": "hallgatoi_kepzes",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.hallgatoi_kepzes),
      callback: function($$v) {
        _vm.form.hallgatoi_kepzes = $$v
      },
      expression: "form.hallgatoi_kepzes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Az ösztöndíjas jogviszony időtartama",
      "id": "jogviszony_idotartam",
      "name": "jogviszony_idotartam",
      "options": _vm.jogviszony_opt,
      "errors": _vm.errors
    },
    on: {
      "onChange": _vm.jogviszonyIdotartamValt
    },
    model: {
      value: (_vm.form.jogviszony_idotartam),
      callback: function($$v) {
        _vm.form.jogviszony_idotartam = $$v
      },
      expression: "form.jogviszony_idotartam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": true,
      "id": "jogviszony_befejezes_idopont",
      "label": "Az ösztöndíjas jogviszony befejezésének időpontja",
      "name": "jogviszony_befejezes_idopont",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.jogviszony_befejezes_idopont),
      callback: function($$v) {
        _vm.form.jogviszony_befejezes_idopont = $$v
      },
      expression: "form.jogviszony_befejezes_idopont"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": "",
      "id": "neptunkod",
      "regexp_filter": "[0-9A-Za-z]{6}",
      "label": "Neptun kód",
      "name": "neptunkod",
      "errors": _vm.errors
    },
    on: {
      "input": function($event) {
        _vm.form.neptunkod = _vm.form.neptunkod.toUpperCase()
      }
    },
    model: {
      value: (_vm.form.neptunkod),
      callback: function($$v) {
        _vm.form.neptunkod = $$v
      },
      expression: "form.neptunkod"
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.save_enabled,
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.save_enabled,
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": function($event) {
        _vm.save(2)
      }
    }
  }, [_vm._v("Véglegesít")])])])]) : _vm._e(), _vm._v(" "), (_vm.fill_info != '') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("ÚNKP-23 Ösztöndíjszerződés adattábla")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  })])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("ÚNKP-23 Ösztöndíjszerződés adattábla")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n          Kérem véglegesítés előtt "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("ellenőrizze")]), _vm._v(" a NEPTUN-ból beemelt adatait! Ha hiányosságot, vagy eltérést tapasztal, akkor azt legyen kedves "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("először a NEPTUN-ban javítani")]), _vm._v(" és utána újra kitölteni, menteni és véglegesíteni az űrlapot. "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Az űrlap alapján elkészült Ösztöndíjszerződésen a későbbiekben nem áll módunkban módosítani!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-234d7705"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/osztondijszerzodes_23.vue
// module id = 343
// module chunks = 0